import React from "react";
import "./WeeklyApplicationStatus.css";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Tooltip,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip);

function WeeklyApplicationStatus() {
  const data = {
    labels: ["Week 1", "Week 2", "Week 3"],
    datasets: [
      { label: "Pending", data: [5, 3, 2], backgroundColor: "orange" },
      { label: "Accepted", data: [8, 10, 12], backgroundColor: "green" },
      { label: "Refused", data: [2, 8, 5], backgroundColor: "red" },
      { label: "Overdue", data: [1, 2, 3], backgroundColor: "blue" },
    ],
  };

  return (
    <div className="Dashboard__WeeklyApplicationStatus card_box">
      <h5 className="mb-3 card_heading_holder" >Weekly Application Status</h5>
       <p>Tasks</p>
      <Bar data={data} options={{ responsive: true }} />
    </div>
  );
}

export default WeeklyApplicationStatus;
